import { all, put, retry } from 'redux-saga/effects';
import moment from 'moment-timezone';
import { saveAs } from 'file-saver';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import { FEED_AUTHORIZATION } from '../constants/feed';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  infoNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';

export function* loadGlobalFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadGlobalFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_GLOBAL_FEEDS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_GLOBAL_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_GLOBAL_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_GLOBAL_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_GLOBAL_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadFeedsGlobal() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadFeedsGlobal);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_FEEDS_GLOBAL),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_FEEDS_GLOBAL),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_FEEDS_GLOBAL),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FEEDS_GLOBAL),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_FEEDS_GLOBAL),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadNewFeedsGlobal() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadNewFeedsGlobal);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_NEW_FEEDS_GLOBAL),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_NEW_FEEDS_GLOBAL),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_NEW_FEEDS_GLOBAL),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_NEW_FEEDS_GLOBAL),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_NEW_FEEDS_GLOBAL),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadFeedPerformance() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadFeedPerformance);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_FEED_PERFORMANCE),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_FEED_PERFORMANCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_FEED_PERFORMANCE),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FEED_PERFORMANCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_FEED_PERFORMANCE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* clearSourcesReports() {
  try {
    //const res = yield retry(4, 500, authClient.IOC.details, {});
    yield put({
      type: resolve(types?.CLEAR_SOURCES_REPORTS),
      //payload: res.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.CLEAR_SOURCES_REPORTS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.CLEAR_SOURCES_REPORTS),
        ),
      }),
    ]);
  }
}

export function* loadSourcesReports(feed_type, sources_uuids) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.loadSourcesReports,
      feed_type,
      sources_uuids,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SOURCES_REPORTS),
        payload: res?.data()?.response,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SOURCES_REPORTS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_SOURCES_REPORTS),
  //     payload: res?.data()?.response,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_SOURCES_REPORTS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_SOURCES_REPORTS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadSourceReport({ feed_uuid, sources_uuids }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadSourceReport, {
      feed_uuid,
      sources_uuids,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SOURCE_REPORT),
        payload: res?.data()?.response,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SOURCE_REPORT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_SOURCE_REPORT),
  //     payload: res?.data().response,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_SOURCE_REPORT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_SOURCE_REPORT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* consumeFeedData({ data }) {
  // console.log('data', data);
  try {
    const res = yield retry(4, 500, authClient?.Feed?.consumeFeedData, {
      body: {
        auth_config:
          data?.authorization === FEED_AUTHORIZATION?.NOT_REQUIRED
            ? null
            : {
                type: data?.authorization,
                username: data?.username,
                password: data?.password,
                token: data?.token,
                threatconnect_id: data?.threatconnect_id,
                threatconnect_secret: data?.threatconnect_secret,
                crowdstrike_id: data?.crowdstrike_id,
                crowdstrike_user_agent: data?.crowdstrike_user_agent,
                crowdstrike_secret: data?.crowdstrike_secret,
              },
        resource_type: data?.type,
        threat_type: data?.threat_type,
        resource_url: data?.url,
        ...(data?.custom_api_key_type === 'x-api-key' && {
          advanced_options: {
            request_method: 'GET',
            headers: { 'x-api-key': data?.custom_api_key_value },
          },
        }),
        ...(data?.custom_api_key_type === 'api-key' && {
          advanced_options: {
            request_method: 'GET',
            headers: { 'api-key': data?.custom_api_key_value },
          },
        }),
        ...(data?.custom_api_key_type === 'api_key' && {
          advanced_options: {
            request_method: 'GET',
            headers: { api_key: data?.custom_api_key_value },
          },
        }),
      },
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CONSUME_FEED_DATA),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.CONSUME_FEED_DATA),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Consuming feed data was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CONSUME_FEED_DATA),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CONSUME_FEED_DATA),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CONSUME_FEED_DATA),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* consumeFileData({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.consumeFeedData, {
      body: {
        auth_config: null,
        resource_type: data?.resource_type,
        threat_type: data?.threat_type,
        resource_base64: data?.resource_base64,
      },
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CONSUME_FILE_DATA),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.CONSUME_FILE_DATA),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Consuming file data was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CONSUME_FILE_DATA),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CONSUME_FILE_DATA),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CONSUME_FILE_DATA),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createVirtualFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.createVirtualFeed, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_VIRTUAL_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Feed has been created successfully.',
          duration: 4,
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_VIRTUAL_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed creation was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_VIRTUAL_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Feed has been created successfully.',
  //       duration: 4,
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_VIRTUAL_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_VIRTUAL_FEED),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateVirtualFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.updateVirtualFeed, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_VIRTUAL_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Feed has been updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_VIRTUAL_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed creation was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_VIRTUAL_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Feed has been updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_VIRTUAL_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_VIRTUAL_FEED),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* verifyAuth({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.verifyAuth, {
      body: {
        auth_config:
          data?.authorization === FEED_AUTHORIZATION?.NOT_REQUIRED
            ? null
            : {
                type: data?.authorization,
                username: data?.username,
                password: data?.password,
                token: data?.token,
                threatconnect_id: data?.threatconnect_id,
                threatconnect_secret: data?.threatconnect_secret,
                crowdstrike_user_agent: data?.crowdstrike_user_agent,
                crowdstrike_id: data?.crowdstrike_id,
                crowdstrike_secret: data?.crowdstrike_secret,
              },
        resource_url: data?.url,
        ...(data?.custom_api_key_type === 'x-api-key' && {
          advanced_options: {
            request_method: 'GET',
            headers: { 'x-api-key': data?.custom_api_key_value },
          },
        }),
        ...(data?.custom_api_key_type === 'api-key' && {
          advanced_options: {
            request_method: 'GET',
            headers: { 'api-key': data?.custom_api_key_value },
          },
        }),
        ...(data?.custom_api_key_type === 'api_key' && {
          advanced_options: {
            request_method: 'GET',
            headers: { api_key: data?.custom_api_key_value },
          },
        }),
      },
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.VERIFY_FEED_AUTH),
        payload: res?.data()?.message,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Auth verified',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.VERIFY_FEED_AUTH),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Auth verification was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.VERIFY_FEED_AUTH),
  //     message: res?.data()?.message,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Auth verified',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.VERIFY_FEED_AUTH),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.VERIFY_FEED_AUTH)),
  //     }),
  //   ]);
  // }
}

export function* createGlobalFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.createGlobal, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_GLOBAL_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source with observable(s) created',
          duration: 4,
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_GLOBAL_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source creation was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_GLOBAL_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source with observable(s) created',
  //       duration: 4,
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_GLOBAL_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_GLOBAL_FEED),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateGlobalFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.updateGlobal, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_GLOBAL_FEED),
        payload: res?.data(),
      });
      res?.data()?.state === 'COLLECTION'
        ? showNotification(
            successNotification({
              statusCode: 200,
              message: 'Source has been updated.',
            }),
          )
        : showNotification(
            successNotification({
              statusCode: 200,
              message: 'Feed has been updated.',
            }),
          );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_GLOBAL_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_GLOBAL_FEED),
  //     payload: res?.data(),
  //   });
  //   res?.data()?.state === 'COLLECTION'
  //     ? showNotification(
  //         successNotification({
  //           statusCode: 200,
  //           message: 'Source has been updated.',
  //         }),
  //       )
  //     : showNotification(
  //         successNotification({
  //           statusCode: 200,
  //           message: 'Feed has been updated.',
  //         }),
  //       );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_GLOBAL_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_GLOBAL_FEED),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteGlobalFeed({ feed }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.deleteGlobal, {
      uuid: feed?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_GLOBAL_FEED),
        uuid: feed?.uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Feed has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_GLOBAL_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed deletion was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_GLOBAL_FEED),
  //     uuid: feed?.uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Feed has been deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_GLOBAL_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_GLOBAL_FEED),
  //       ),
  //     }),
  //   ]);
  // }
}

// export function* loadFeeds() {
//   try {
//     const res = yield retry(4, 500, authClient.Feed.load);

//     yield put({
//       type: resolve(types.LOAD_FEEDS),
//       payload: res.data().results,
//     });
//   } catch (error) {
//     yield all([
//       put({
//         type: reject(types.LOAD_FEEDS),
//         error,
//       }),
//       put({
//         type: NOTIFICATION.ADD_NOTIFICATION,
//         notification: errorNotification(error, reject(types.LOAD_FEEDS)),
//       }),
//     ]);
//   }
// }

export function* loadCollections() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadCollections);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_COLLECTIONS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_COLLECTIONS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collections list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_COLLECTIONS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_COLLECTIONS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_COLLECTIONS)),
  //     }),
  //   ]);
  // }
}

export function* loadFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_FEEDS),
        payload: res?.data()?.results,
      });
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feeds list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* loadNewFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadNewFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_NEW_FEEDS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_NEW_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feeds list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_NEW_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_NEW_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_NEW_FEEDS)),
  //     }),
  //   ]);
  // }
}

export function* loadOrganizationCollections() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.loadOrganizationCollections,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_ORGANIZATION_COLLECTIONS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_ORGANIZATION_COLLECTIONS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Organization Collections list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_ORGANIZATION_COLLECTIONS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_ORGANIZATION_COLLECTIONS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_ORGANIZATION_COLLECTIONS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadOrganizationFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadOrganizationFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_ORGANIZATION_FEEDS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_ORGANIZATION_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Organization Feeds list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_ORGANIZATION_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_ORGANIZATION_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_ORGANIZATION_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadNewOrganizationFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadNewOrganizationFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_NEW_ORGANIZATION_FEEDS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_NEW_ORGANIZATION_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Organization Feeds list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_NEW_ORGANIZATION_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_NEW_ORGANIZATION_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_NEW_ORGANIZATION_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMyCollections() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadMyCollections);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_MY_COLLECTIONS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_MY_COLLECTIONS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Private Collections list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_MY_COLLECTIONS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_MY_COLLECTIONS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_MY_COLLECTIONS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMyFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadMyFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_MY_FEEDS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_MY_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Private Feeds list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_MY_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_MY_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_MY_FEEDS)),
  //     }),
  //   ]);
  // }
}

export function* loadNewMyFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadNewMyFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_NEW_MY_FEEDS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_NEW_MY_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Private Feeds list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_NEW_MY_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_NEW_MY_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_NEW_MY_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadAllFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadAllFeeds);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_ALL_FEEDS),
        payload: res?.data()?.results,
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Feed has been deleted',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_ALL_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feeds list load unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_ALL_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_ALL_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_ALL_FEEDS)),
  //     }),
  //   ]);
  // }
}

export function* saveEmptyCollection({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.saveEmptyCollection, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_EMPTY_COLLECTION),
        payload: res?.data()?.results,
      });
      res?.data()?.state === 'COLLECTION'
        ? showNotification(
            successNotification({
              statusCode: 200,
              message: 'Collection has been created successfully.',
            }),
          )
        : showNotification(
            successNotification({
              statusCode: 200,
              message: 'Feed has been created successfully.',
            }),
          );
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_EMPTY_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source creation unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_EMPTY_COLLECTION),
  //     payload: res?.data(),
  //   });
  //   res?.data()?.state === 'COLLECTION'
  //     ? showNotification(
  //         successNotification({
  //           statusCode: 200,
  //           message: 'Collection has been created successfully.',
  //         }),
  //       )
  //     : showNotification(
  //         successNotification({
  //           statusCode: 200,
  //           message: 'Feed has been created successfully.',
  //         }),
  //       );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_EMPTY_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_EMPTY_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportFeed({ uuid }) {
  try {
    //const apiEndpoint = ;

    //const sortOrder = yield select(getSortOrder);
    //const filterProfile = yield select(getFilterProfile);
    // const paramsObject = buildGetParamsObject(
    //   { ...params, sortOrder, filterProfile },
    //   limit,
    // );
    const res = yield retry(4, 500, authClient?.Feed?.exportFeed, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      const response = res?.data();
      yield put({
        type: resolve(types?.EXPORT_FEED),
        // payload: res?.data()?.results,
      });
      showNotification(
        infoNotification({
          statusCode: 100,
          message:
            'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed export unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   const response = res?.data();
  //   // console.log(response);
  //   yield put({
  //     type: resolve(types?.EXPORT_FEED),
  //     // payload: response,
  //   });

  //   showNotification(
  //     infoNotification({
  //       statusCode: 100,
  //       message:
  //         'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
  //     }),
  //   );

  //   // saveAs(
  //   //   response,
  //   //   'export_' + moment().format('YYYY-MM-DD_HHmmss').toString() + '.csv',
  //   // );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.EXPORT_FEED)),
  //     }),
  //   ]);
  // }
}

export function* uploadToCollection({ data, originator }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.uploadToCollection, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPLOAD_TO_COLLECTION),
        payload: res?.data(),
        originator: originator,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'The observable(s) have been added to the source',
          duration: 4,
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPLOAD_TO_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Add to Collection unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPLOAD_TO_COLLECTION),
  //     payload: res?.data(),
  //     originator: originator,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'The observable(s) have been added to the source',
  //       duration: 4,
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPLOAD_TO_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPLOAD_TO_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.create, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message:
            'Feed has been created successfully. Feed items will be active in 120 minutes.',
          duration: 4,
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed creation unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message:
  //         'Feed has been created successfully. Feed items will be active in 120 minutes.',
  //       duration: 4,
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.CREATE_FEED)),
  //     }),
  //   ]);
  // }
}

export function* updateFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.update, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message:
            'Feed has been created successfully. Feed items will be active in 120 minutes.',
          duration: 4,
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed update unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Feed has been updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.UPDATE_FEED)),
  //     }),
  //   ]);
  // }
}

export function* createCollectionByFileUpload({ data, originator }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.createCollectionByFileUpload,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_COLLECTION_BY_FILE_UPLOAD),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source with observable(s) created',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_COLLECTION_BY_FILE_UPLOAD),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collection creation unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_COLLECTION_BY_FILE_UPLOAD),
  //     payload: res?.data(),
  //     originator: originator,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source with observable(s) created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_COLLECTION_BY_FILE_UPLOAD),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_COLLECTION_BY_FILE_UPLOAD),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createCollectionByURLUpload({ data, originator }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.createCollectionByURLUpload,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_COLLECTION_BY_URL_UPLOAD),
        payload: res?.data(),
        originator: originator,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source with observable(s) created',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_COLLECTION_BY_URL_UPLOAD),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collection creation unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_COLLECTION_BY_URL_UPLOAD),
  //     payload: res?.data(),
  //     originator: originator,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source with observable(s) created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_COLLECTION_BY_URL_UPLOAD),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_COLLECTION_BY_URL_UPLOAD),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateCollection({ data, originator }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.updateCollection, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_COLLECTION),
        payload: res?.data(),
        originator: originator,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_COLLECTION),
  //     payload: res?.data(),
  //     originator: originator,
  //   });

  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeCollection({ data, originator }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.changeScopeCollection, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_COLLECTION),
        payload: res?.data(),
        originator: originator,
      });
      const message =
        data?.scope == 'ORGANISATION'
          ? 'Source has been shared with your organization'
          : 'Source has been updated';
      res?.data()?.state === 'COLLECTION'
        ? showNotification(
            successNotification({
              statusCode: 200,
              message: 'Source has been updated',
            }),
          )
        : showNotification(
            successNotification({
              statusCode: 200,
              message: message,
            }),
          );
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SCOPE_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Change scope unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_COLLECTION),
  //     payload: res?.data(),
  //     originator: originator,
  //   });

  //   const message =
  //     data?.scope == 'ORGANISATION'
  //       ? 'Source has been shared with your organization'
  //       : 'Source has been updated';
  //   res?.data()?.state === 'COLLECTION'
  //     ? showNotification(
  //         successNotification({
  //           statusCode: 200,
  //           message: 'Source has been updated',
  //         }),
  //       )
  //     : showNotification(
  //         successNotification({
  //           statusCode: 200,
  //           message: message,
  //         }),
  //       );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* publishCollection({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.publishCollection, {
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.PUBLISH_COLLECTION),
        uuid: data?.uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Collection has been published',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.PUBLISH_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collection publish was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.PUBLISH_COLLECTION),
  //     uuid: data?.uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Collection has been published',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.PUBLISH_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.PUBLISH_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* shareCollection({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.shareCollection, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SHARE_COLLECTION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Collection has been shared.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.SHARE_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collection share was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SHARE_COLLECTION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SHARE_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.SHARE_COLLECTION)),
  //     }),
  //   ]);
  // }
}

export function* deleteFeed({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.deleteFeed, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_FEED),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Feed has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed deletion was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_FEED),
  //     uuid: uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Feed has been deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.DELETE_FEED)),
  //     }),
  //   ]);
  // }
}

export function* deleteMyFeed({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.deleteMyFeed, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MY_FEED),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Feed has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MY_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed deletion was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MY_FEED),
  //     uuid: uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Feed has been deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MY_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.DELETE_MY_FEED)),
  //     }),
  //   ]);
  // }
}

export function* deleteOrganizationFeed({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.deleteOrganizationFeed, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_ORGANIZATION_FEED),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Feed has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_ORGANIZATION_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed deletion was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_ORGANIZATION_FEED),
  //     uuid: uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Feed has been deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_ORGANIZATION_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_ORGANIZATION_FEED),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteCollection({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.deleteCollection, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_COLLECTION),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Collection has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collection deletion was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_COLLECTION),
  //     uuid: uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Collection has been deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* activateCollection({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.activateCollection, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ACTIVATE_COLLECTION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ACTIVATE_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ACTIVATE_COLLECTION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ACTIVATE_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.ACTIVATE_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* activateFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.activateFeed, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ACTIVATE_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ACTIVATE_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ACTIVATE_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ACTIVATE_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.ACTIVATE_FEED)),
  //     }),
  //   ]);
  // }
}

export function* activateMyFeed({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.activateMyFeed, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ACTIVATE_MY_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ACTIVATE_MY_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ACTIVATE_MY_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ACTIVATE_MY_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.ACTIVATE_MY_FEED)),
  //     }),
  //   ]);
  // }
}

export function* activateOrganizationFeed({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.activateOrganizationFeed,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ACTIVATE_ORGANIZATION_FEED),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ACTIVATE_ORGANIZATION_FEED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ACTIVATE_ORGANIZATION_FEED),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ACTIVATE_ORGANIZATION_FEED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.ACTIVATE_ORGANIZATION_FEED),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadCollection({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadCollection, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_COLLECTION),
        payload: res?.data(),
      });
      //   showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Source has been updated.',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collection load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_COLLECTION),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_COLLECTION)),
  //     }),
  //   ]);
  // }
}

export function* loadAvailableFeeds() {
  try {
    const res = yield retry(4, 500, authClient?.Feed?.loadAvailable);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_AVAILABLE_FEEDS),
        payload: res?.data()?.results,
      });
      //   showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Source has been updated.',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_AVAILABLE_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_AVAILABLE_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_AVAILABLE_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_AVAILABLE_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadIPEditableFeeds({ state }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.loadIPEditableFeeds,
      state,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_IP_EDITABLE_FEEDS),
        payload: res?.data()?.results,
      });
      //   showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Source has been updated.',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_IP_EDITABLE_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_IP_EDITABLE_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_IP_EDITABLE_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_IP_EDITABLE_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadDomainEditableFeeds({ state }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.loadDomainEditableFeeds,
      state,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_DOMAIN_EDITABLE_FEEDS),
        payload: res?.data()?.results,
      });
      //   showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Source has been updated.',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_DOMAIN_EDITABLE_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_DOMAIN_EDITABLE_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_DOMAIN_EDITABLE_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_DOMAIN_EDITABLE_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadURLEditableFeeds({ state }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Feed?.loadURLEditableFeeds,
      state,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_URL_EDITABLE_FEEDS),
        payload: res?.data()?.results,
      });
      //   showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Source has been updated.',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_URL_EDITABLE_FEEDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Feed load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_URL_EDITABLE_FEEDS),
  //     payload: res?.data()?.results,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_URL_EDITABLE_FEEDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_URL_EDITABLE_FEEDS),
  //       ),
  //     }),
  //   ]);
  // }
}
